import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircleIcon, CheckCircle2Icon, CalendarIcon } from 'lucide-react';
export function VideoSection() {
  const bullets = ['Learn how the therapy works', 'Understand what sessions are like', 'Ask about the intro offer'];
  return <section id="video-section" className="py-16 md:py-20 bg-gradient-to-br from-brand-navy via-brand-charcoal to-brand-navy relative overflow-hidden" data-id="element-282">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-teal/15 rounded-full blur-[120px] pointer-events-none" data-id="element-283" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-teal/5 rounded-full blur-[100px] pointer-events-none" data-id="element-284" />

      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-285">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 max-w-3xl mx-auto" data-id="element-286">
          <div className="inline-block py-1 px-3 rounded-full bg-brand-teal/20 border border-brand-teal/40 text-brand-teal text-[11px] font-black tracking-widest uppercase mb-4" data-id="element-287">
            Patient Education
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight" data-id="element-288">
            Watch the Aspen Laser Patient Education Video
          </h2>
          <p className="text-base md:text-lg text-teal-50/90 leading-relaxed" data-id="element-289">
            See how photobiomodulation therapy works and why many patients
            choose laser therapy as a non-invasive option for pain,
            inflammation, and recovery support.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-center" data-id="element-290">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-8" data-id="element-291">
            <div className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-2xl ring-2 ring-white/20 bg-brand-charcoal" data-id="element-292">
              {/* Visible placeholder underneath iframe — always visible until iframe loads */}
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-brand-charcoal to-brand-navy" data-id="element-293">
                <div className="w-20 h-20 bg-brand-teal rounded-full flex items-center justify-center mb-4 shadow-2xl shadow-brand-teal/40" data-id="element-294">
                  <PlayCircleIcon className="w-12 h-12 text-white" data-id="element-295" />
                </div>
                <p className="text-white font-bold text-lg" data-id="element-296">
                  Aspen Laser Patient Education Video
                </p>
                <p className="text-teal-200/70 text-sm mt-1" data-id="element-297">
                  Loading video...
                </p>
              </div>
              <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/fJ5evRvEv0s" title="Aspen Laser Patient Education Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-298"></iframe>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="lg:col-span-4" data-id="element-299">
            <div className="bg-white p-6 md:p-7 rounded-2xl shadow-2xl" data-id="element-300">
              <div className="w-11 h-11 bg-brand-teal rounded-xl flex items-center justify-center mb-4 text-white shadow-md shadow-brand-teal/30" data-id="element-301">
                <PlayCircleIcon className="w-5 h-5" data-id="element-302" />
              </div>
              <h3 className="text-lg md:text-xl font-black text-brand-navy mb-3 leading-tight" data-id="element-303">
                After Watching, Ask Us If Laser Therapy Fits Your Situation
              </h3>
              <p className="text-gray-600 text-sm mb-5 leading-relaxed" data-id="element-304">
                Every patient is unique. A free consultation helps determine if
                Aspen laser therapy is an appropriate option for you.
              </p>

              <ul className="space-y-2.5 mb-6" data-id="element-305">
                {bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2.5" data-id="element-306">
                    <CheckCircle2Icon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-307" />
                    <span className="text-brand-charcoal font-medium text-sm leading-snug" data-id="element-308">
                      {bullet}
                    </span>
                  </li>)}
              </ul>

              <a href="#consultation-form" className="inline-flex w-full px-5 py-3 bg-brand-teal hover:bg-brand-teal-dark text-white rounded-lg font-bold text-sm md:text-base transition-all duration-300 items-center justify-center gap-2 shadow-lg shadow-brand-teal/30" data-id="element-309">
                <CalendarIcon className="w-5 h-5" data-id="element-310" />
                Request a Consultation
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}